import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/index.vue'

// 定义白名单路由
const whiteList = ['/auth/login', '/auth/register', '/auth/change-password']

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/Login.vue'),
        meta: { title: '登录' }
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/auth/Register.vue'),
        meta: { title: '注册' }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/auth/ChangePassword.vue'),
        meta: { title: '忘记/修改密码' }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'dialog-demo',
        name: 'DialogDemo',
        component: () => import('@/views/DialogDemo.vue'),
        meta: { title: '对话框演示' }
      },
      // 基础数据管理 - 流向数据 - 有码
      {
        path: 'basic-data/flow-data/with-code',
        name: 'FlowDataWithCode',
        component: () => import('@/views/basic-data/flow-data/WithCode.vue'),
        meta: { title: '数据明细' }
      },
      // 产品组
      {
        path: '/basic-data/prod-group/group-list',
        name: 'ProdGroupList',
        component: () => import('@/views/basic-data/prod-group/ProdGroup.vue'),
        meta: { title: '产品组' }
      },
      {
        path: '/basic-data/prod-group/group-detail',
        name: 'ProdGroupDetail',
        component: () => import('@/views/basic-data/prod-group/ProdGroupDetail.vue'),
        meta: { title: '产品组详情' }
      },
      // 基础数据管理 - 流向数据 - 无码
      // {
      //   path: 'basic-data/flow-data/without-code',
      //   name: 'FlowDataWithoutCode',
      //   component: () => import('@/views/basic-data/flow-data/WithoutCode.vue'),
      //   meta: { title: '流向数据-无码' }
      // },
      // 基础数据管理 - 流向数据 - 销量标记
      {
        path: 'basic-data/flow-data/sales-mark',
        name: 'FlowDataSalesMark',
        component: () => import('@/views/basic-data/flow-data/SalesMark.vue'),
        meta: { title: '销量标记' }
      },
      // 基础数据管理 - 经销商主数据
      {
        path: 'basic-data/dealer-data',
        name: 'DealerData',
        component: () => import('@/views/basic-data/DealerData.vue'),
        meta: { title: '经销商主数据' }
      },
      // 基础数据管理 - 经销商特批返还
      {
        path: 'basic-data/customer-return',
        name: 'CustomerReturn',
        component: () => import('@/views/basic-data/CustomerReturn.vue'),
        meta: { title: '经销商特批返还' }
      },
      // 基础数据管理 - 门店主数据
      {
        path: 'basic-data/store-data',
        name: 'StoreData',
        component: () => import('@/views/basic-data/StoreData.vue'),
        meta: { title: '门店主数据' }
      },
      // 基础数据管理 - 黑名单
      {
        path: 'basic-data/blacklist',
        name: 'Blacklist',
        component: () => import('@/views/basic-data/Blacklist.vue'),
        meta: { title: '黑名单' }
      },
      // 基础数据管理 - 窜货盒数处罚规则
      {
        path: 'basic-data/box-punishment-rules',
        name: 'BoxPunishmentRules',
        component: () => import('@/views/basic-data/BoxPunishmentRules.vue'),
        meta: { title: '窜货盒数处罚规则' }
      },
      // 基础数据管理 - 窜货家数处罚规则
      {
        path: 'basic-data/store-punishment-rules',
        name: 'StorePunishmentRules',
        component: () => import('@/views/basic-data/StorePunishmentRules.vue'),
        meta: { title: '窜货家数处罚规则' }
      },
      // 基础数据管理 - 产品转换规则
      {
        path: 'basic-data/product-rules',
        name: 'ProductRules',
        component: () => import('@/views/basic-data/ProductRules.vue'),
        meta: { title: '产品转换规则' }
      },

      // 基础数据管理 - 白名单
      {
        path: 'basic-data/whitelist',
        name: 'WhiteList',
        component: () => import('@/views/basic-data/WhiteList.vue'),
        meta: { title: '白名单' }
      },

      // 计算结果 - 产品盒数-季度
      {
        path: 'calculation/product-quantity-quarter',
        name: 'ProductQuantityQuarter',
        component: () => import('@/views/calculation-result/QuarterlyBoxes.vue'),
        meta: { title: '按盒数汇总' }
      },
      // 计算结果 - 产品盒数-月度
      {
        path: 'calculation/product-quantity-month',
        name: 'ProductQuantityMonth',
        component: () => import('@/views/calculation-result/MonthlyBoxes.vue'),
        meta: { title: '按盒数汇总' }
      },
      // 计算结果 - 平台店铺数-季度
      {
        path: 'calculation/avg-store-quarter',
        name: 'AvgStoreQuarter',
        component: () => import('@/views/calculation-result/AvgStoreQuarter.vue'),
        meta: { title: '按店铺数汇总' }
      },
      // 计算结果 - 平台店铺数-月度
      {
        path: 'calculation/avg-store-month',
        name: 'AvgStoreMonth',
        component: () => import('@/views/calculation-result/AvgStoreMonth.vue'),
        meta: { title: '按店铺数汇总' }
      },
      // 计算结果 - 产品店铺数-季度
      {
        path: 'calculation/product-store-quarter',
        name: 'ProductStoreQuarter',
        component: () => import('@/views/calculation-result/ProductStoreQuarter.vue'),
        meta: { title: '产品店铺数' }
      },
      // 计算结果 - 产品店铺数-月度
      {
        path: 'calculation/product-store-month',
        name: 'ProductStoreMonth',
        component: () => import('@/views/calculation-result/ProductStoreMonth.vue'),
        meta: { title: '产品店铺数' }
      },
      {
        path: '/calculation/monthDetail',
        name: 'PunishmentMonthDetails',
        component: () => import('@/views/calculation-result/PunishmentMonthDetails.vue'),
        meta: { title: '处罚数据' }
      },
      // 计算结果 - 处罚报告季度汇总
      {
        path: 'calculation/punishment-total',
        name: 'PunishmentTotal',
        component: () => import('@/views/calculation-result/PunishmentTotal.vue'),
        meta: { title: '处罚报告季度汇总' }
      },
      // 计算结果 - 处罚数据
      {
        path: 'calculation/punishment-details',
        name: 'PunishmentDetails',
        component: () => import('@/views/calculation-result/PunishmentDetails.vue'),
        meta: { title: '处罚数据' }
      },

      // 用户管理
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue'),
        meta: { title: '用户管理' }
      },

      // 历史版本
      {
        path: 'history-version',
        name: 'HistoryVersion',
        component: () => import('@/views/HistoryVersion.vue'),
        meta: { title: '历史版本' }
      },

      // 数据导出记录
      {
        path: 'export-records',
        name: 'ExportRecords',
        component: () => import('@/views/ExportRecords.vue'),
        meta: { title: '数据导出记录' }
      },

      // 测试DS
      // {
      //   path: 'test-ds',
      //   name: 'TestDS',
      //   component: () => import('@/views/TestDS.vue'),
      //   meta: { title: '测试DS' }
      // }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.MODE === 'development' ? '/' : import.meta.env.VITE_BASE_URL),
  routes
})

// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 获取token
  const token = localStorage.getItem('token')
  const userInfo = localStorage.getItem('userInfo')

  // 在白名单中，直接放行
  if (whiteList.includes(to.path)) {
    if (token && to.path.startsWith('/auth')) {
      // 已登录状态访问登录页，跳转到首页
      next('/')
    } else {
      next()
    }
    return
  }

  // 未登录，重定向到登录页
  if (!token || !userInfo) {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    next(`/auth/login?redirect=${to.path}`)
    return
  }

  // 已登录，放行
  next()
})

export default router